import { useState } from "react";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { CheckCircle2, AlertCircle } from "lucide-react";
import { LucideIcon } from "lucide-react";

interface PaymentProviderProps {
  id: string;
  name: string;
  icon: LucideIcon;
  enabled: boolean;
  mode: 'test' | 'live';
  configured: boolean;
  onToggle: (id: string) => void;
  onModeChange: (id: string, mode: 'test' | 'live') => void;
}

const PaymentProvider = ({
  id,
  name,
  icon: Icon,
  enabled,
  mode,
  configured,
  onToggle,
  onModeChange,
}: PaymentProviderProps) => {
  return (
    <div className="space-y-4 pt-4">
      <div className="flex items-center justify-between">
        <div className="space-y-1">
          <Label>Enable {name}</Label>
          <p className="text-sm text-muted-foreground">
            Allow payments through {name}
          </p>
        </div>
        <Switch
          checked={enabled}
          onCheckedChange={() => onToggle(id)}
        />
      </div>

      <div className="flex items-center gap-2">
        <Badge variant={configured ? "outline" : "secondary"}>
          {configured ? (
            <CheckCircle2 className="h-3 w-3 mr-1" />
          ) : (
            <AlertCircle className="h-3 w-3 mr-1" />
          )}
          {configured ? "Configured" : "Not Configured"}
        </Badge>
        <Badge variant={mode === 'live' ? "destructive" : "outline"}>
          {mode === 'live' ? 'Live' : 'Test'}
        </Badge>
      </div>

      <div className="space-y-2">
        <Label>API Keys</Label>
        <div className="grid gap-2">
          <Input
            type="password"
            placeholder={`${name} Secret Key`}
            disabled={!enabled}
          />
          <Input
            placeholder={`${name} Public Key`}
            disabled={!enabled}
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label>Environment</Label>
        <div className="flex gap-2">
          <Button
            variant={mode === 'test' ? "default" : "outline"}
            size="sm"
            onClick={() => onModeChange(id, 'test')}
            disabled={!enabled}
          >
            Test Mode
          </Button>
          <Button
            variant={mode === 'live' ? "default" : "outline"}
            size="sm"
            onClick={() => onModeChange(id, 'live')}
            disabled={!enabled}
          >
            Live Mode
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentProvider;